export const fakeRequest = () => {
    return new Promise(resolve => setTimeout(() => resolve(), 2000));
};

export const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height,
    };
};

export const getRequestHash = () => {
    return window.location.href.split('/')[window.location.href.split('/').length - 1].split('?')[0];
}

export const dataUriToBase64 = dataUri => {
    const base64 = dataUri.split('base64,');
    return base64[base64.length - 1];
};

export function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}
